import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import styled from 'styled-components';
import { Quiz } from '../../models/Quiz';
import { useQuizPage } from './quiz-page.hook';

import QuizPageComponent from './quiz';
import useQueryParams from '../../hooks/useQueryParams';
import { QuizResultComponent } from './quiz-results-page';

export type QuizAttemptParams = {
  quizId: string;
};

export const QuizAttemptPage = () => {
  const { push } = useHistory();
  const { quizId } = useParams<QuizAttemptParams>();
  const { sa } = useQueryParams(); // sa = show answers
  const [quiz, setQuiz] = useState<Quiz>();
  const [isLoading, setIsLoading] = useState(true);
  const { getQuizById } = useQuizPage();

  useEffect(() => {
    const fetchedQuiz = getQuizById(quizId);
    if (fetchedQuiz) {
      setQuiz(fetchedQuiz);
    }
    setIsLoading(false);
  }, [quizId, getQuizById]);

  const showResults = sa === 'true';

  const canAcess = quiz && quiz.attempts < 2;

  if (quiz && showResults && quiz.attempts >= 2) {
    return (
      <QuizResultComponent
        questions={quiz.questions}
        score={quiz.note || 0}
        studentAnswers={quiz.answers || {}}
      />
    );
  }

  if (isLoading) {
    return <div>Carregando quiz...</div>;
  }

  return (
    <div>
      {quiz && canAcess ? (
        <QuizPageComponent quiz={quiz} />
      ) : (
        <NotAllowedContainer>
          {quiz && quiz.attempts >= 2 && (
            <>
              <h1>Quiz não disponível</h1>
              <p>
                Este quiz já foi concluído ou não está mais disponível. Você só
                pode tentar este quiz uma vez.
              </p>
              <button type="button" onClick={() => push('/quiz')}>
                Voltar para Quizzes
              </button>
            </>
          )}
        </NotAllowedContainer>
      )}
    </div>
  );
};

const NotAllowedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;

  h1 {
    font-size: 2rem;
    margin-bottom: 1rem;
  }

  p {
    font-size: 1.2rem;
    margin-bottom: 2rem;
  }

  button {
    padding: 0.5rem 1rem;
    font-size: 1rem;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 0.25rem;
    cursor: pointer;

    &:hover {
      background-color: #0056b3;
    }
  }
`;
